import { css } from '@/styled-system/css';

export const poiInfoCardContainer = css({
  width: 'PropertyCard.Root.large.min',
});

export const poiInfoCardCloseButton = css({
  left: 'auto',
  right: 'tightest',
});

export const poiInfoCardContent = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'tighter',
});

export const poiInfoCardHeader = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: 'tightest',
  paddingInlineEnd: 'looser',
});

export const poiInfoCardTitle = css({
  color: 'text.neutral',
  fontSize: { base: 'body-sm', lg: 'body' },
  fontWeight: 'bold',
  lineHeight: { base: 'body-sm', lg: 'body' },
  margin: 'zero',
});

export const poiInfoCardMeta = css({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: 'tighter',
  color: 'text.subtle',
  fontSize: { base: 'body-xs', lg: 'body-sm' },
  lineHeight: { base: 'body-xs', lg: 'body-sm' },
});

export const poiInfoCardMetaItem = css({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 'tightest',
});

export const poiInfoCardAttributionList = css({
  display: 'flex',
  flexWrap: 'wrap',
  gap: 'tightest',
  color: 'text.subtle',
  fontSize: 'fineprint',
  lineHeight: 'body-xs',
});
